const React = require('react');

/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 10 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`dB fillCT>path ` + (props.className || '')}
    >
      <path d="M5,18c-2.8,0-5-2.2-5-5V0h10v13C10,15.8,7.8,18,5,18z M1,1v12c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4V1H1z"/>
      <rect x="2" y="3" width="6" height="9" fill="white"/>
    </svg>
  );
};
